'use client';

import { api } from '~/libs/api';
import { useTripBookingStore } from '~/stores/tpv2/tripBookingStore';

export const useConfirmTripDetails = () => {
  const markDatesConfirmedFor = useTripBookingStore((s) => s.markDatesConfirmedFor);
  const clearDatesConfirmedFor = useTripBookingStore((s) => s.clearDatesConfirmedFor);
  const utils = api.useUtils();
  const { mutate } = api.trip.confirmDetails.useMutation({
    onMutate: ({ tripId }) => {
      const previousOverview = utils.trip.getOverview.getData({ tripId });
      utils.trip.getOverview.setData({ tripId }, (data) =>
        data ? { ...data, tripDetailsConfirmedAt: new Date().toISOString() } : data
      );
      return { previousOverview };
    },
    onError: (_error, { tripId }, context) => {
      clearDatesConfirmedFor(tripId);
      if (context?.previousOverview) utils.trip.getOverview.setData({ tripId }, context.previousOverview);
    }
  });

  return (tripId: string, onSuccess?: () => void) => {
    markDatesConfirmedFor(tripId);
    mutate({ tripId }, { onSuccess });
  };
};
